import { WidgetsSupportStaffFormMain } from '@/widgets/support-staff-form';

export const PagesSupportStaffCreateMain = () => <WidgetsSupportStaffFormMain mode="create" />;
